import { AuthStatus } from 'src/data/types/base';
import { AcceptInvitation } from 'src/data/types/invitations/types';
import { MfaResetResponse } from 'src/types';
import { createController, createControllerEndpoint } from 'src/utils/api';

export default createController('/account', {
    signIn: createControllerEndpoint<{ authStatus: AuthStatus }>('POST', '/signin'),
    setPassword: createControllerEndpoint<void>('POST', '/inv-set-pass'),
    acceptInvitation: createControllerEndpoint<AcceptInvitation>('POST', '/accept-invitation'),
    resetMfa: createControllerEndpoint<MfaResetResponse>('POST', '/mfa/reset'),
    getHmacSignature: createControllerEndpoint<any>('POST', '/hmac'),
});